import { INFORMES_CONCILIACION_PATH, RESULTADO_A_REVISAR } from './informesHub'

export const LEFTOVER_MOTIVO_NOT_IN = ['COMPRA', 'VENTA']

export const informeArticleLabel = (fila) => {
    if (!fila) return ''
    const codigo = fila.codigo != null ? String(fila.codigo).trim() : ''
    const nombre = fila.nombre != null ? String(fila.nombre).trim() : ''
    return [codigo, nombre].filter(Boolean).join(' - ')
}

const formatHistorialHeaderNumber = (value) => {
    if (value == null || value === '' || Number.isNaN(Number(value))) {
        return '0.00'
    }
    return Number(value).toFixed(2)
}

export const buildLeftoverHistorialFilters = ({ from, to }) => ({
    from,
    to,
    motivoNotIn: LEFTOVER_MOTIVO_NOT_IN,
})

export const isInformeRowClickable = (fila) =>
    Boolean(
        fila &&
            fila.articuloId != null &&
            fila.resultado === RESULTADO_A_REVISAR
    )

export const shouldChangeRouteOnHistorialOpen = () => false

export const informeHistorialStayPath = () => INFORMES_CONCILIACION_PATH

export const mapInformeFilaToHistorialProps = (fila, context) => ({
    articuloId: fila.articuloId,
    articuloNombre: informeArticleLabel(fila),
    sucursalId: context.sucursalId,
    filters: buildLeftoverHistorialFilters({
        from: context.from,
        to: context.to,
    }),
    headerLabel: 'Diferencia',
    headerValue: formatHistorialHeaderNumber(fila.diferencia),
    subtitleLabel: 'Final',
    subtitleValue: formatHistorialHeaderNumber(fila.final),
    trigger: 'name',
})
